<template>
  <Slide>
    <Grid
      slideTag="about"
      @animationCallbackReady="
        callback => $emit('animationCallbackReady', callback)
      "
    >
      <transition name="slide" slot="col-1">
        <h2 v-if="appLoaded" class="heading typ__size_lg typ__leading_loose">
          I'm
          <em class="typ__style_bold">Miguel</em>. And I obsess over web design.
        </h2>
      </transition>
      <div slot="col-2">
        <div class="transition-box">
          <transition name="slide-up">
            <p v-if="appLoaded" class="typ__size_md paragraph-indent">
              I deployed my first website when I was 17 and have kept building
              ever since. In 2018, I graduated Cum Laude with a degree in
              Computer Science at the Ateneo de Manila University. Currently, I
              am a Software Engineer at YC startup
              <a
                href="https://paymongo.com/"
                target="_blank"
                rel="noopener"
                >PayMongo</a
              >.
            </p>
          </transition>
        </div>
        <div class="transition-box">
          <transition name="slide-up">
            <div v-if="appLoaded">
              <p class="typ__size_md paragraph-indent">
                My mission is to elevate the standard of web design and
                development in the Philippines.
              </p>
              <ul class="profile-links__list typ__size_md paragraph-indent">
                <li class="profile-links__list-item">
                  <a
                    href="https://www.linkedin.com/in/galacemiguel"
                    aria-label="View my LinkedIn profile"
                  >
                    <LinkedInIcon class="profile-links__icon" />
                    <span class="profile-links__text">LinkedIn</span>
                  </a>
                </li>
                <li class="profile-links__list-item">
                  <a href="https://github.com/galacemiguel" aria-label="View my GitHub profile">
                    <GitHubIcon class="profile-links__icon" />
                    <span class="profile-links__text">GitHub</span>
                  </a>
                </li>
                <li class="profile-links__list-item">
                  <a
                    href="https://www.behance.net/galacemiguel"
                    aria-label="View my Behance profile"
                  >
                    <BehanceIcon class="profile-links__icon" />
                    <span class="profile-links__text">Behance</span>
                  </a>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </Grid>
  </Slide>
</template>

<script>
import Slide from '@/components/Slide.vue'
import Grid from '@/components/Grid.vue'
import LinkedInIcon from '@/assets/images/linkedin.svg'
import GitHubIcon from '@/assets/images/github.svg'
import BehanceIcon from '@/assets/images/behance.svg'

export default {
  name: 'AboutSlide',
  components: {
    Slide,
    Grid,
    LinkedInIcon,
    GitHubIcon,
    BehanceIcon
  },
  props: {
    appLoaded: Boolean
  }
}
</script>

<style scoped lang="scss">
.heading {
  margin-bottom: 0;
  will-change: transform;
}

.profile-links {
  &__list {
    margin-bottom: 1em;
  }

  &__list-item {
    display: inline-block;
    margin-right: 1em;
  }

  &__icon {
    height: 2em;
    fill: $clr__body;
    margin-right: .5em;
  }

  &__text {
    display: none;
  }

  &__list-item:hover {
    .profile-links__icon {
      fill: $clr__body-dark;
    }
  }
}

@include md-screen {
  .heading {
    position: relative;
    top: -.38em;
    width: 90%;
  }

  .profile-links {
    &__icon {
      height: 1em;
    }

    &__text {
      display: unset;
    }
  }
}

/* * * * * * * * * *
 * TRANSITIONS
 */
.slide-enter-active {
  transition: transform $tm__intro-animation $tm__ease-in-out-quint;
}

.slide-up-enter-active {
  transition: transform $tm__intro-animation 500ms $tm__ease-in-out-quint;
}

.slide-enter {
  transform: translateX(-100%);
}

.slide-up-enter {
  transform: translateY(calc(100% + 1em));
}
</style>
